import {darCodeI18nKey, darTypeI18nKey} from "@/lib/utils";
import type {TFunction} from "i18next";

export function tDarCodeName(name: string, t: TFunction): string {
  const key = darCodeI18nKey(name) as string | null;
  return key ? t(key, {ns: "dar", defaultValue: name}) : name;
}

export function tDarTypeName(name: string, t: TFunction): string {
  const key = darTypeI18nKey(name) as string | null;
  return key ? t(key, {ns: "dar", defaultValue: name}) : name;
}
